import { render, staticRenderFns } from "./PrivateChatMenu.vue?vue&type=template&id=5269b0c9&scoped=true"
import script from "./PrivateChatMenu.vue?vue&type=script&lang=js"
export * from "./PrivateChatMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5269b0c9",
  null
  
)

export default component.exports